import { Input } from "@/components/ui/input";
import { Field, StructuredRecord, SwitchField, formatCell, EmptyState, PAGE_SIZE, PageError } from "./ui-helpers";

export { formatCell, EmptyState, PAGE_SIZE, PageError };

export function DynamicField({ name, value, readOnly, json, onChange }: { name: string; value: unknown; readOnly: boolean; json: boolean; onChange: (value: unknown) => void }) {
  if (json || (value && typeof value === "object")) return <StructuredRecord title={name} value={value} compact />;
  if (typeof value === "boolean") return <SwitchField label={name} checked={value} onChange={onChange as (value: boolean) => void} disabled={readOnly} />;
  return <Field label={name}><Input disabled={readOnly} value={String(value ?? "")} onChange={(event) => onChange(event.target.value)} /></Field>;
}
